import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

export function AuthImage({ fileId, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    const token = localStorage.getItem("evo_token");
    fetch(`${API}/files/${fileId}/download`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((b) => { url = URL.createObjectURL(b); setSrc(url); })
      .catch(() => {});
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  if (!src) return <div className={`animate-pulse bg-slate-800 ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}
